import { render, staticRenderFns } from "./SpecialtyAdd.vue?vue&type=template&id=70b490e5&"
import script from "./SpecialtyAdd.vue?vue&type=script&lang=js&"
export * from "./SpecialtyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports